import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { orange1, orange9 } from 'approot/shared/styles/colours.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import { TextStyled } from 'approot/shared/styles/typography/text.style';

type UnidentifiedAccessBannerProps = {
  $isFixed?: boolean;
};

export const UnidentifiedAccessBanner = styled.div<UnidentifiedAccessBannerProps>`
  background-color: ${orange1};
  padding: ${rem(spacing16)};
  width: 100%;
`;

type UnidentifiedAccessBannerContentProps = {
  $colour?: string;
};

export const UnidentifiedAccessBannerContent = styled.div<UnidentifiedAccessBannerContentProps>`
  ${flexCentreAlignCss}
  flex-wrap: wrap;
  gap: ${rem(spacing16)};

  ${PStyled}, ${TextStyled} {
    color: ${({ $colour }) => $colour || orange9};
  }
`;
